import styled from 'styled-components'
import { Box, Text } from '@usap/uicomponents'

export const HTMLMainContainer = styled(Box)`
  flex-direction: row;
  padding: ${({ containerCondition, theme }) => (containerCondition && theme.mediaQuery.up('desktop') ? 0 : '16px')};
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    flex-direction: column;
    padding: 8px;
  }
`

export const HTMLOuterContainer = styled(Box)`
  width: ${({ returnsCenter, theme }) => (
    !returnsCenter && theme.mediaQuery.down('tablet-landscape')
      ? '998px'
      : '100%'
  )}
`

export const HTMLInnerContainer = styled(Box)`
  padding-left: ${({ isSpecificPages }) => (isSpecificPages ? 0 : '24px')}
`

export const HTMLBody = styled(Text)`
  line-height: 23px;
`
